import styles from './Input.module.scss'
import React, {useLayoutEffect, useRef, useState} from "react";
import {InputPropsInterface} from "./Input.props.interface";
import Message from "../Message";

const Input: React.FC<InputPropsInterface> = (
    {
        inputRef,
        label = undefined,
        size = 'medium',
        error = undefined,
        className = undefined,
        prefix,
        suffix,
        ...rest
    }
) => {
    const prefixRef = useRef<HTMLDivElement | null>(null);
    const suffixRef = useRef<HTMLDivElement | null>(null);

    const [paddingLeft, setPaddingLeft] = useState<string | undefined>(undefined);
    const [paddingRight, setPaddingRight] = useState<string | undefined>(undefined);

    useLayoutEffect(() => {
        if (prefixRef.current) setPaddingLeft(`${prefixRef.current.offsetWidth + 20}px`);
        else setPaddingLeft(undefined);

        if (suffixRef.current) setPaddingRight(`${suffixRef.current.offsetWidth + 20}px`);
        else setPaddingRight(undefined);
    }, [prefix, suffix]);

    return (
        <label
            htmlFor={rest.id}
            className={[
                styles.container,
                error ? styles.error : null,
                styles[size],
                className,
            ].filter(Boolean).join(' ')}>
            {label}
            <div className={styles.wrapper}>
                {prefix ? <div className={styles.icon} ref={prefixRef}>
                    {prefix}
                </div> : null}
                <input
                    {...rest}
                    ref={inputRef}
                    value={rest.value || ''}
                    style={{
                        ...(rest.style || {}),
                        paddingLeft,
                        paddingRight,
                    }}
                />
                {suffix ? <div className={styles.icon} ref={suffixRef}>
                    {suffix}
                </div> : null}
            </div>
            {error ? <Message>{error}</Message> : null}
        </label>
    );
}

export default Input;
